export default "__VITE_ASSET__B39fT$3R__"